import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
